import { Injectable } from '@angular/core';
import { FormActionHandlerService } from './base.service';
import { NavService } from '../../../fastlane-common/services/nav.service';
import { UserContextService } from '../../../user/services/user-context.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';

@Injectable()
export class CloseFormActionHandlerService extends FormActionHandlerService {

  constructor(
    private navService: NavService,
    private swal: SwalService,
    private userContext: UserContextService
  ) {
    super();
  }

  exec(): Promise<any> {
    const that = this;
    return new Promise((resolve, reject) => {
      if (that.userContext.isUserGuest()) {
        // Guest users get logged out of the system
        // Use a swal to ask if they really want to leave or not
        that.swal.warn({
          title: 'You are now leaving this page.',
          text: 'However, you will be able to come back to this page via the URL you used to reach this page initally.',
          showCancelButton: true,
          confirmButtonText: 'Logout',
          cancelButtonText: 'Stay'
        }).then(
          () => {
            resolve();
            // Log user out
            that.navService.toLogin();
          }
        ).catch(resolve);
      } else {
        resolve();

        // Redirects users to previous page no matter the form type (i.e. if on application, clicking close will redirect back to either "Forms" page or 
        // or "Project Summary" page depending on how the form was accessed).

        that.navService.back();

      }
    });
  }

}
